/**
* @Description: 正在开发中样式
* @Params:
* @Return:
* @Author: BEN
* @Date: 2021/3/1 11:11
*/
export default {
  inserted(el, binding, vnode) {
    const { value } = binding;
    if(el) {
      el.style.opacity = 0.4;
      if( el.parentNode) {
        el.parentNode.style.cursor = 'not-allowed';
        el.parentNode.setAttribute('title', '功能正在开发中...')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/developing/developing.js